import { render, staticRenderFns } from "./MagazineButtons.vue?vue&type=template&id=16da29aa&lang=html&"
import script from "./MagazineButtons.vue?vue&type=script&lang=js&"
export * from "./MagazineButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports